import gql from "graphql-tag";
export default {
  myRole: gql`
    query {
      myRole {
        id
        isOwner
        isAdmin
        approvalManagements {
          id
          formName
        }
      }
    }
  `,
};
